// SEQ-193: the one RPC call behind the Project performance table's By month
// view. It is the existing debounced, error-surfacing grain hook at the new
// `project_month` grain, so it behaves like every other P&L call on the page.
//
// `enabled` is the By month switch (and "the range is one the RPC accepts").
// While it is false nothing is fetched at all, which is what keeps the default
// Totals view exactly as cheap as it was before this existed.
//
// `current` says whether the rows held were fetched for the filters now being
// asked for. While a refetch is pending (the hook debounces, then loads) the
// previous rows are still held, and drawing them under the new month columns
// would be wrong, so the table shows its loading state until `current`.

import { FIXTURE_PNL_ANALYTICS_MONTH_RESPONSE } from "./fixtures";
import { PNL_ROLLUP_METRICS } from "./rollup";
import {
  useOnePnlAnalyticsGrain,
  type PnlAnalyticsQueryFilters,
  type UsePnlAnalyticsGrainResult,
} from "./usePnlAnalytics";
import { grainRequestKey, isMonthDataCurrent } from "./projectMonthView";

// No fixture rows: in development with the RPC missing, the by month view shows an empty grid rather than invented figures.
export const EMPTY_FIXTURE = { rows: [], meta: FIXTURE_PNL_ANALYTICS_MONTH_RESPONSE.meta };

export interface UsePnlProjectMonthsResult extends UsePnlAnalyticsGrainResult {
  current: boolean;
}

export function usePnlProjectMonths(filters: PnlAnalyticsQueryFilters, enabled: boolean): UsePnlProjectMonthsResult {
  const result = useOnePnlAnalyticsGrain(filters, "project_month", PNL_ROLLUP_METRICS, EMPTY_FIXTURE, enabled);
  return { ...result, current: isMonthDataCurrent(result.dataKey, grainRequestKey(filters, "project_month", PNL_ROLLUP_METRICS)) };
}
